<template>
    <div class='page'>
        <el-form v-if='send' ref='form' :inline='true' :model='queryForm' class='query-form' label-width='80px'
                 size='small' @submit.native.prevent>
            <el-form-item label='字典类型'>
                <el-input v-model='queryForm.dictType' placeholder='请输入字典类型' @input='editDictType'></el-input>
            </el-form-item>
            <el-form-item label='字典描述'>
                <el-input v-model='queryForm.dictName' placeholder='请输入字典描述' @input='editDictName'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon='el-icon-search' size='small' type='primary' @click="checkState = 'check'">查询
                </el-button>
                <el-button icon='el-icon-refresh' size='small' @click="checkState = 'reset'">重置</el-button>
            </el-form-item>
        </el-form>
        <DictTypeListTable :checkState='checkState' :data='this.data' :queryForm='queryForm' @resetCheckState='resetCheckState'
                           @send='getData' @resetCheckStates='resetCheckStates'></DictTypeListTable>
    </div>
</template>

<script>
import DictTypeListTable from '@/components/system/DictTypeListTable.vue';

export default {
    components: {
        DictTypeListTable
    },
    data() {
        return {
            queryForm: {
                dictType: '',
                dictName: ''
            },
            send: '',
            data: '',
            checkState: ''
        };
    },
    methods: {
        getData(data) {
            this.send = data;
        },
        resetCheckState() {
            if (this.checkState == 'reset') {
                this.queryForm = {
                    dictType: '',
                    dictName: ''
                };
            }
            this.checkState = '';
        },
        resetCheckStates(val){
            if (val == 'kong') {
                this.queryForm = {
                    dictType: '',
                    dictName: ''
                };
            }
        },
        editDictType(e) {
            this.checkState = '';
        },
        editDictName(e) {
            this.checkState = '';
        }
    }
};
</script>

<style lang='scss' scoped></style>
